var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1444.563,
    height: 1254.092,
    viewBox: "0 0 1444.563 1254.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M970.2,196.092,941,635.683a92.969,92.969,0,0,1-92.969,92.969h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H201.028l29.2-377.58Z",
    transform: "translate(-201.028 -196.092)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3080-2",
    "data-name": "Path 3080",
    d: "M970.2,196.092,941,635.683a92.969,92.969,0,0,1-92.969,92.969h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H201.028l29.2-377.58Z",
    transform: "translate(-201.028 -196.092)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Extension",
    transform: "translate(-2242.719 -3229.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email_update",
    "data-name": "Email update",
    transform: "translate(2019 1505.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(-4530.33 -1494.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(-2077.952 3178.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M1361.367,1177.549c209.991-204.2,220.738-517.33-158.32-868.486-54.978-51.051-81.847-122.15-136.411-160.387-165.347-115.95-397.453-92.388-543.579,79.78C443.07,322.7,410.827,452.088,327.74,544.476,234.526,648.231,122.916,749.093,80.546,890.465c-28.109,93.628-23.355,195.73,8.681,287.291C549.719,1259.6,985,1284.818,1361.367,1177.549Z",
    transform: "translate(6769.949 45.96)",
    fill: "#c2b59c",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    transform: "translate(3321.709 3229.863)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    d: "M900.1,595.78A154.105,154.105,0,1,0,1054.2,749.885,154.106,154.106,0,0,0,900.1,595.78Zm0,282.855a128.75,128.75,0,1,1,128.75-128.75A128.835,128.835,0,0,1,900.1,878.635Z",
    transform: "translate(-745.99 -595.78)",
    fill: "#acd6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    "data-name": "Path 3245",
    d: "M840.843,670.37a20.292,20.292,0,1,1-20.28-20.28A20.265,20.265,0,0,1,840.843,670.37Z",
    transform: "translate(-666.533 -516.264)",
    fill: "#acd6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M816.23,614.02a13.014,13.014,0,0,0-13.01,13.01V717.39a13.01,13.01,0,0,0,26.021,0V627.031A13,13,0,0,0,816.23,614.02Z",
    transform: "translate(-662.199 -569.075)",
    fill: "#acd6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    d: "M890.509,631.392a13,13,0,0,0-18.383,0l-63.894,63.894a13,13,0,0,0,18.383,18.382l63.894-63.894A12.955,12.955,0,0,0,890.509,631.392Z",
    transform: "translate(-660.435 -549.214)",
    fill: "#acd6ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7bdc07120c027be48c81a0b2532a9b05",
    "data-name": "7bdc07120c027be48c81a0b2532a9b05",
    transform: "translate(2366.535 3482.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M1059.149,992.162H199.578a14.745,14.745,0,0,1-14.73-15.408L220.379,188.81a14.745,14.745,0,0,1,14.73-14.08H1094.68a14.745,14.745,0,0,1,14.729,15.409l-35.531,787.943A14.745,14.745,0,0,1,1059.149,992.162Z",
    transform: "translate(-82.411 -128.661)",
    fill: "#83a87f",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M477.3,188.811a14.744,14.744,0,0,0-14.729-14.08h-5.014a14.745,14.745,0,0,1,14.73,15.409L436.754,978.082a14.744,14.744,0,0,1-14.729,14.081h149.8a14.744,14.744,0,0,0,14.73-15.409Z",
    transform: "translate(554.713 -128.661)",
    fill: "#3d4b3b",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M971.616,909.576h-759.1A13.021,13.021,0,0,1,199.5,895.969l31.379-695.844a13.021,13.021,0,0,1,13.008-12.434H1003A13.021,13.021,0,0,1,1016,201.3L984.625,897.144a13.021,13.021,0,0,1-13.01,12.432Z",
    transform: "translate(-43.036 -93.847)",
    fill: "#749072",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M280.518,205.8a5.267,5.267,0,0,1-.627,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.642,14.892-20.642,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.916,30,20.568,30a10.773,10.773,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.935,21.935,0,0,1-3.465.258c-16.846,0-30.705-18.209-31.664-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.7-43.57C266.29,162.232,280.518,181.768,280.518,205.8Z",
    transform: "translate(4.208 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M310.785,205.8a5.267,5.267,0,0,1-.627,2.507h-9.8a5.264,5.264,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.774,10.774,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.935,21.935,0,0,1-3.465.258c-16.883,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C296.52,162.232,310.785,181.768,310.785,205.8Z",
    transform: "translate(85.409 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    "data-name": "Path 3056",
    d: "M340.988,205.8a5.266,5.266,0,0,1-.627,2.507h-9.805a5.267,5.267,0,0,1-.627-2.507c0-17.62-9.473-32.512-20.642-32.512-11.206,0-20.679,14.892-20.679,32.512,0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.657,10.657,0,0,0,1.843-.147,5.534,5.534,0,0,1,1.622,10.948,22.6,22.6,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C326.76,162.232,340.988,181.768,340.988,205.8Z",
    transform: "translate(166.637 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    "data-name": "Path 3057",
    d: "M371.255,205.8a5.264,5.264,0,0,1-.627,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.937,21.937,0,0,1-3.465.258c-16.845,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.265-43.57,31.737-43.57C357.027,162.232,371.255,181.768,371.255,205.8Z",
    transform: "translate(247.838 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    "data-name": "Path 3058",
    d: "M401.458,205.8a5.266,5.266,0,0,1-.627,2.507h-9.8a5.267,5.267,0,0,1-.627-2.507c0-17.62-9.436-32.511-20.642-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.885,17.472,11.132,31.516,22.448,29.858a5.534,5.534,0,1,1,1.622,10.948,22.276,22.276,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C387.23,162.232,401.458,181.768,401.458,205.8Z",
    transform: "translate(329.066 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    "data-name": "Path 3059",
    d: "M431.7,205.8a5.265,5.265,0,0,1-.626,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.642,14.892-20.642,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.916,30,20.568,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,0,1,1.585,10.948,21.929,21.929,0,0,1-3.465.258c-16.845,0-30.705-18.209-31.664-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.229-43.57,31.7-43.57C417.47,162.232,431.7,181.768,431.7,205.8Z",
    transform: "translate(410.294 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3060",
    "data-name": "Path 3060",
    d: "M459.755,205.8a5.265,5.265,0,0,1-.627,2.507h-9.8a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,22.271,22.271,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C445.49,162.232,459.755,181.768,459.755,205.8Z",
    transform: "translate(485.559 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3061",
    "data-name": "Path 3061",
    d: "M450.165,368.694H437.89v-.442Q443.972,368.694,450.165,368.694Z",
    transform: "translate(597.328 391.161)",
    fill: "#25788e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    "data-name": "Path 3062",
    d: "M970.2,196.092,941,635.683a92.969,92.969,0,0,1-92.969,92.969h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H201.028l29.2-377.58Z",
    transform: "translate(-38.909 -71.28)",
    fill: "#6a8967"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(162.119 124.812)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    "data-name": "Path 3064",
    d: "M365.447,344.154H232.68a10.523,10.523,0,0,1-10.513-11L227.6,212.77a10.523,10.523,0,0,1,10.513-10.049H370.874a10.523,10.523,0,0,1,10.513,11L375.958,334.1a10.523,10.523,0,0,1-10.511,10.049Z",
    transform: "translate(-144.273 -178.286)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M410.915,344.154H278.153a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H416.345a10.523,10.523,0,0,1,10.513,11l-5.43,120.387A10.523,10.523,0,0,1,410.915,344.154Z",
    transform: "translate(-22.13 -178.286)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M456.386,344.154H323.624a10.523,10.523,0,0,1-10.513-11L318.54,212.77a10.523,10.523,0,0,1,10.513-10.049H461.816a10.524,10.524,0,0,1,10.513,11L466.9,334.1a10.524,10.524,0,0,1-10.514,10.049Z",
    transform: "translate(100.01 -178.286)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M501.861,344.154H369.095a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H507.287a10.524,10.524,0,0,1,10.513,11L512.371,334.1A10.523,10.523,0,0,1,501.861,344.154Z",
    transform: "translate(222.15 -178.286)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M363.394,386.634H230.628a10.524,10.524,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,236.056,245.2H368.82a10.523,10.523,0,0,1,10.513,11L373.9,376.585A10.524,10.524,0,0,1,363.394,386.634Z",
    transform: "translate(-149.788 -64.18)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M408.862,386.634H276.1a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.524,10.524,0,0,1,281.529,245.2H414.292a10.523,10.523,0,0,1,10.513,11l-5.43,120.387a10.523,10.523,0,0,1-10.513,10.048Z",
    transform: "translate(-27.645 -64.18)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    d: "M454.333,386.634H321.571a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,327,245.2H459.763a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,454.333,386.634Z",
    transform: "translate(94.496 -64.18)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M499.808,386.634H367.042a10.524,10.524,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,372.47,245.2H505.234a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.524,10.524,0,0,1,499.808,386.634Z",
    transform: "translate(216.636 -64.18)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M362.015,429.114H229.248a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H367.441a10.524,10.524,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,362.015,429.114Z",
    transform: "translate(-153.492 49.926)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M407.483,429.114H274.721a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H412.913a10.524,10.524,0,0,1,10.513,11L418,419.066a10.523,10.523,0,0,1-10.513,10.048Z",
    transform: "translate(-31.349 49.926)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M452.954,429.114H320.192a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H458.384a10.524,10.524,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,452.954,429.114Z",
    transform: "translate(90.791 49.926)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M498.429,429.114H365.663a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H503.855a10.523,10.523,0,0,1,10.513,11l-5.429,120.387a10.523,10.523,0,0,1-10.51,10.049Z",
    transform: "translate(212.931 49.926)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M360.366,471.436H227.6a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.524,10.524,0,0,1,233.032,330H365.8a10.523,10.523,0,0,1,10.513,11L370.88,461.387A10.523,10.523,0,0,1,360.366,471.436Z",
    transform: "translate(-157.91 163.607)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M405.837,471.436H273.075a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,278.5,330H411.267a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,405.837,471.436Z",
    transform: "translate(-35.77 163.607)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M451.309,471.436H318.547a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,323.975,330H456.739a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,451.309,471.436Z",
    transform: "translate(86.373 163.607)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M496.78,471.436H364.018a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,369.446,330H502.21a10.523,10.523,0,0,1,10.513,11l-5.429,120.387a10.523,10.523,0,0,1-10.514,10.049Z",
    transform: "translate(208.513 163.607)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M0,74.394",
    transform: "translate(96.701 221.958)",
    fill: "none",
    stroke: "#ee781d",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M99.518,0",
    transform: "translate(-99.518 548.711)",
    fill: "none",
    stroke: "#3086a3",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7bdc07120c027be48c81a0b2532a9b05-2",
    "data-name": "7bdc07120c027be48c81a0b2532a9b05",
    transform: "translate(2366.535 3482.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3051-2",
    "data-name": "Path 3051",
    d: "M1059.149,992.162H199.578a14.745,14.745,0,0,1-14.73-15.408L220.379,188.81a14.745,14.745,0,0,1,14.73-14.08H1094.68a14.745,14.745,0,0,1,14.729,15.409l-35.531,787.943A14.745,14.745,0,0,1,1059.149,992.162Z",
    transform: "translate(-82.411 -128.661)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052-2",
    "data-name": "Path 3052",
    d: "M477.3,188.811a14.744,14.744,0,0,0-14.729-14.08h-5.014a14.745,14.745,0,0,1,14.73,15.409L436.754,978.082a14.744,14.744,0,0,1-14.729,14.081h149.8a14.744,14.744,0,0,0,14.73-15.409Z",
    transform: "translate(554.713 -128.661)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053-2",
    "data-name": "Path 3053",
    d: "M971.616,909.576h-759.1A13.021,13.021,0,0,1,199.5,895.969l31.379-695.844a13.021,13.021,0,0,1,13.008-12.434H1003A13.021,13.021,0,0,1,1016,201.3L984.625,897.144a13.021,13.021,0,0,1-13.01,12.432Z",
    transform: "translate(-43.036 -93.847)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3054-2",
    "data-name": "Path 3054",
    d: "M280.518,205.8a5.267,5.267,0,0,1-.627,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.642,14.892-20.642,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.916,30,20.568,30a10.773,10.773,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.935,21.935,0,0,1-3.465.258c-16.846,0-30.705-18.209-31.664-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.7-43.57C266.29,162.232,280.518,181.768,280.518,205.8Z",
    transform: "translate(4.208 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3055-2",
    "data-name": "Path 3055",
    d: "M310.785,205.8a5.267,5.267,0,0,1-.627,2.507h-9.8a5.264,5.264,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.774,10.774,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.935,21.935,0,0,1-3.465.258c-16.883,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C296.52,162.232,310.785,181.768,310.785,205.8Z",
    transform: "translate(85.409 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056-2",
    "data-name": "Path 3056",
    d: "M340.988,205.8a5.266,5.266,0,0,1-.627,2.507h-9.805a5.267,5.267,0,0,1-.627-2.507c0-17.62-9.473-32.512-20.642-32.512-11.206,0-20.679,14.892-20.679,32.512,0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.657,10.657,0,0,0,1.843-.147,5.534,5.534,0,0,1,1.622,10.948,22.6,22.6,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C326.76,162.232,340.988,181.768,340.988,205.8Z",
    transform: "translate(166.637 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3057-2",
    "data-name": "Path 3057",
    d: "M371.255,205.8a5.264,5.264,0,0,1-.627,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.937,21.937,0,0,1-3.465.258c-16.845,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.265-43.57,31.737-43.57C357.027,162.232,371.255,181.768,371.255,205.8Z",
    transform: "translate(247.838 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058-2",
    "data-name": "Path 3058",
    d: "M401.458,205.8a5.266,5.266,0,0,1-.627,2.507h-9.8a5.267,5.267,0,0,1-.627-2.507c0-17.62-9.436-32.511-20.642-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.885,17.472,11.132,31.516,22.448,29.858a5.534,5.534,0,1,1,1.622,10.948,22.276,22.276,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C387.23,162.232,401.458,181.768,401.458,205.8Z",
    transform: "translate(329.066 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059-2",
    "data-name": "Path 3059",
    d: "M431.7,205.8a5.265,5.265,0,0,1-.626,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.642,14.892-20.642,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.916,30,20.568,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,0,1,1.585,10.948,21.929,21.929,0,0,1-3.465.258c-16.845,0-30.705-18.209-31.664-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.229-43.57,31.7-43.57C417.47,162.232,431.7,181.768,431.7,205.8Z",
    transform: "translate(410.294 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3060-2",
    "data-name": "Path 3060",
    d: "M459.755,205.8a5.265,5.265,0,0,1-.627,2.507h-9.8a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,22.271,22.271,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C445.49,162.232,459.755,181.768,459.755,205.8Z",
    transform: "translate(485.559 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M268.779,453.5h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H837.951l9.781,74.165A92.969,92.969,0,0,0,939.9,453.5Z",
    transform: "translate(-137.777 203.866)",
    fill: "#466543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3061-2",
    "data-name": "Path 3061",
    d: "M450.165,368.694H437.89v-.442Q443.972,368.694,450.165,368.694Z",
    transform: "translate(597.328 391.161)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062-2",
    "data-name": "Path 3062",
    d: "M970.2,196.092,941,635.683a92.969,92.969,0,0,1-92.969,92.969h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H201.028l29.2-377.58Z",
    transform: "translate(-38.909 -71.28)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3063",
    "data-name": "Path 3063",
    d: "M268.779,453.5h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H837.951l9.781,74.165A92.969,92.969,0,0,0,939.9,453.5Z",
    transform: "translate(-130.778 203.866)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_613-2",
    "data-name": "Group 613",
    transform: "translate(162.119 124.812)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3064-2",
    "data-name": "Path 3064",
    d: "M365.447,344.154H232.68a10.523,10.523,0,0,1-10.513-11L227.6,212.77a10.523,10.523,0,0,1,10.513-10.049H370.874a10.523,10.523,0,0,1,10.513,11L375.958,334.1a10.523,10.523,0,0,1-10.511,10.049Z",
    transform: "translate(-144.273 -178.286)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065-2",
    "data-name": "Path 3065",
    d: "M410.915,344.154H278.153a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H416.345a10.523,10.523,0,0,1,10.513,11l-5.43,120.387A10.523,10.523,0,0,1,410.915,344.154Z",
    transform: "translate(-22.13 -178.286)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066-2",
    "data-name": "Path 3066",
    d: "M456.386,344.154H323.624a10.523,10.523,0,0,1-10.513-11L318.54,212.77a10.523,10.523,0,0,1,10.513-10.049H461.816a10.524,10.524,0,0,1,10.513,11L466.9,334.1a10.524,10.524,0,0,1-10.514,10.049Z",
    transform: "translate(100.01 -178.286)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067-2",
    "data-name": "Path 3067",
    d: "M501.861,344.154H369.095a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H507.287a10.524,10.524,0,0,1,10.513,11L512.371,334.1A10.523,10.523,0,0,1,501.861,344.154Z",
    transform: "translate(222.15 -178.286)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068-2",
    "data-name": "Path 3068",
    d: "M363.394,386.634H230.628a10.524,10.524,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,236.056,245.2H368.82a10.523,10.523,0,0,1,10.513,11L373.9,376.585A10.524,10.524,0,0,1,363.394,386.634Z",
    transform: "translate(-149.788 -64.18)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069-2",
    "data-name": "Path 3069",
    d: "M408.862,386.634H276.1a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.524,10.524,0,0,1,281.529,245.2H414.292a10.523,10.523,0,0,1,10.513,11l-5.43,120.387a10.523,10.523,0,0,1-10.513,10.048Z",
    transform: "translate(-27.645 -64.18)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070-2",
    "data-name": "Path 3070",
    d: "M454.333,386.634H321.571a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,327,245.2H459.763a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,454.333,386.634Z",
    transform: "translate(94.496 -64.18)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071-2",
    "data-name": "Path 3071",
    d: "M499.808,386.634H367.042a10.524,10.524,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,372.47,245.2H505.234a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.524,10.524,0,0,1,499.808,386.634Z",
    transform: "translate(216.636 -64.18)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072-2",
    "data-name": "Path 3072",
    d: "M362.015,429.114H229.248a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H367.441a10.524,10.524,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,362.015,429.114Z",
    transform: "translate(-153.492 49.926)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073-2",
    "data-name": "Path 3073",
    d: "M407.483,429.114H274.721a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H412.913a10.524,10.524,0,0,1,10.513,11L418,419.066a10.523,10.523,0,0,1-10.513,10.048Z",
    transform: "translate(-31.349 49.926)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074-2",
    "data-name": "Path 3074",
    d: "M452.954,429.114H320.192a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H458.384a10.524,10.524,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,452.954,429.114Z",
    transform: "translate(90.791 49.926)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075-2",
    "data-name": "Path 3075",
    d: "M498.429,429.114H365.663a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H503.855a10.523,10.523,0,0,1,10.513,11l-5.429,120.387a10.523,10.523,0,0,1-10.51,10.049Z",
    transform: "translate(212.931 49.926)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076-2",
    "data-name": "Path 3076",
    d: "M360.366,471.436H227.6a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.524,10.524,0,0,1,233.032,330H365.8a10.523,10.523,0,0,1,10.513,11L370.88,461.387A10.523,10.523,0,0,1,360.366,471.436Z",
    transform: "translate(-157.91 163.607)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077-2",
    "data-name": "Path 3077",
    d: "M405.837,471.436H273.075a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,278.5,330H411.267a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,405.837,471.436Z",
    transform: "translate(-35.77 163.607)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078-2",
    "data-name": "Path 3078",
    d: "M451.309,471.436H318.547a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,323.975,330H456.739a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,451.309,471.436Z",
    transform: "translate(86.373 163.607)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079-2",
    "data-name": "Path 3079",
    d: "M496.78,471.436H364.018a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,369.446,330H502.21a10.523,10.523,0,0,1,10.513,11l-5.429,120.387a10.523,10.523,0,0,1-10.514,10.049Z",
    transform: "translate(208.513 163.607)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081-2",
    "data-name": "Path 3081",
    d: "M0,74.394",
    transform: "translate(96.701 221.958)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082-2",
    "data-name": "Path 3082",
    d: "M99.518,0",
    transform: "translate(-99.518 548.711)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M3021.311,3278.408h98.3",
    transform: "translate(151.856 105.56)",
    fill: "none",
    stroke: "#d1e8d1",
    strokeLinecap: "round",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M0,0H98.3",
    transform: "translate(3222.319 3334.816) rotate(90)",
    fill: "none",
    stroke: "#d1e8d1",
    strokeLinecap: "round",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814",
    transform: "translate(1736.131 -8125.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M1841.024-1491.9c86.476,3.917,175.092,2.738,261.964,3.51,82.531.745,168.549,6.248,250.742,3.157,14.343-.542,12.906-10.069-.55-10.9-85.222-5.231-176.039-1.545-262.117-2.792-83.081-1.193-167.447-4.147-250.5-2.358C1828.365-1501,1829.313-1492.426,1841.024-1491.9Z",
    transform: "translate(-315.641 13969.349) rotate(-18)",
    fill: "#231f1f",
    stroke: "#000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M1832.773-1492.983c8.953,3.489,18.128,2.438,27.123,3.127,8.545.664,17.451,5.565,25.961,2.812,1.485-.483,1.336-8.969-.057-9.705-8.823-4.66-18.226-1.376-27.139-2.487-8.6-1.062-17.337-3.694-25.936-2.1C1831.463-1501.1,1831.561-1493.454,1832.773-1492.983Z",
    transform: "matrix(0.643, -0.766, 0.766, 0.643, 921.494, 14350.002)",
    fill: "#231f1f",
    stroke: "#000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M1832.773-1492.983c8.953,3.489,18.128,2.438,27.123,3.127,8.545.664,17.451,5.565,25.961,2.812,1.485-.483,1.336-8.969-.057-9.705-8.823-4.66-18.226-1.376-27.139-2.487-8.6-1.062-17.337-3.694-25.936-2.1C1831.463-1501.1,1831.561-1493.454,1832.773-1492.983Z",
    transform: "translate(-1151.704 13064.559) rotate(12)",
    fill: "#231f1f",
    stroke: "#000",
    strokeWidth: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.7d102d4ea5b58505ea12101b4083ee70.svg";
export { ForwardRef as ReactComponent };